/**
 * Narrows a free string to a member of a generated OpenAPI enum.
 *
 * The generated client declares request/response enums as TypeScript `enum`s,
 * which are NOMINAL: a string literal — or a member of a different enum with
 * identical values — is not assignable to them. Wire responses, on the other
 * hand, are typed as bare `string` almost everywhere. This helper crosses that
 * boundary with a real runtime check instead of a cast, and returns `undefined`
 * for anything outside the enum so the caller decides the fallback.
 *
 * ```ts
 * const scope = toEnumMember(shifts_UpdateShiftSeriesRequest.update_scope, raw);
 * ```
 */
export function toEnumMember<TEnum extends Record<string, string>>(
  enumObject: TEnum,
  value: string | null | undefined,
): TEnum[keyof TEnum] | undefined {
  if (value === null || value === undefined) return undefined;
  const members = Object.values(enumObject) as Array<TEnum[keyof TEnum]>;
  return members.find((member) => member === value);
}
